import React, { useState } from 'react';
import './Plasticcratesinj.css';
import Plasticcr1 from '../../../imgs/Plasticcrate1.webp';
import Plasticcr2 from '../../../imgs/Plasticcrate2.webp';
import Plasticcr3 from '../../../imgs/Plasticcrate3.webp';
import Plasticcr4 from '../../../imgs/Plasticcrate4.webp';
import Reqprodcte from "../../../components/Reqprodcte";


const images = [
    { src: Plasticcr1 },
    { src: Plasticcr2 },
    { src: Plasticcr3 },
    { src: Plasticcr4 },
];

const Plasticcratesinj = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="Plasticcr-main-container">

            <div className="Plasticcr-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"}data-aos="fade-down"  key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image" />
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots"data-aos="fade-down">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            <div className="Plasticcr-text"data-aos="fade-down">
                <h2>Plastic Crates Injection Molding Machine</h2>
                <h3>FB SERIES</h3>
                <p>
                    Plastic crates as the kind of low-margin product made with recycled material, it requires high production efficiency of the machines. Powerjet has developed a special series for product like fruit crates. The Plastic Crates Injection Molding Machine works perfectly well with the crate molds, ensuring higher production capability and stable product quality.</p>             <ul>
                    <li><strong>Clamping Force:</strong> –  430/450/550Ton</li>
                    <li><strong>Shot Weight(PS):</strong> –  2587~3656g</li>

                    <li><strong>Applications :</strong> - Plastic Crates For Food & Non-Food Products</li>
                </ul>
                <div className='stnd'>
                    <Reqprodcte />
                </div>      
                      </div>
        </div>
    );
};
export default Plasticcratesinj;
